import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { VueSlideToggle } from "vue-slide-toggle";
import orderItem from "../order-item/index.vue";

export default {
    props: ["item"],
    name: "active-orders",
    data() {
        return {
            openitemInfo: false,
        };
    },
    components: {
        VueSlideToggle,
        orderItem,
    },
    computed: {
        ...mapGetters({
            activeOrderListLength: "profile/activeOrderListLength",
            user: "profile/user",
        }),

        isAgent() {
            return this.user.agent_status === 2;
        },
        // only bonuses already credited by the backend; the frontend never calculates them
        hasCreditedBonuses() {
            return this.item.products.some(product => product.bonuses);
        },
        totalBonuses() {
            return this.item.products.reduce((accumulator, product) => {
                return accumulator + (product.bonuses ? parseFloat(product.bonuses) : 0);
            }, 0);
        },
        totalAmount() {
            return this.item.products.reduce((accumulator, currentValue) => {
                return (
                    accumulator +
                    (currentValue.discount_price ? currentValue.discount_price : currentValue.select_price) *
                        currentValue.select_count
                );
            }, 0);
        },
    },
    created() {
        // this.fetchActiveOrderList();
        // this.fetchUserData();
        // console.log(this.item);
    },
    methods: {
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            fetchActiveOrderList: `profile/GET_ACTIVE_ORDER_LIST`,
            removeOrder: `profile/DELETE_ORDER`,
        }),
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        deleteOrder() {
            this.removeOrder(this.item.id).then(() => {
                this.$toasted.success(this.$t("successCancelOrder"));
                this.fetchActiveOrderList();
            });
        },
    },
};
